import SvgIcon from "./SvgIcon"
import AppTablePage from "./AppTablePage"
import txtProcess from "./txtProcess"

export default {
    install(Vue) {
        Vue.component('svg-icon', SvgIcon)
        Vue.component('table-page', AppTablePage)
        Vue.component('txtProcess', txtProcess)
    }
}
